import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebUserDropdownComponent } from './web-user-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [WebUserDropdownComponent],
  exports: [WebUserDropdownComponent]
})
export class WebUserDropdownModule { }
